import axios from "axios"
import { TallyConfig } from "../helpers/constants"
import { xmlToJs } from "../helpers/xmltojs"
import * as moment from "moment"
import { SyncAccStatment, SyncOutStandings, SyncStockSummary } from "../sync/reports"
import { xmlFormatter } from "../helpers/xmlFormatter"
import { compressHtml } from "../helpers/brotliCompression"

export async function GetOutStandingOfAllParties() {

    let sundryDebtorsGrps = JSON.parse(window.localStorage.getItem(`tally-${TallyConfig.company}-groups`))?.sundryDebtorsGrps || []

    let filter = sundryDebtorsGrps.map((grp) => `$Parent="${grp}"`).join(" OR ")
    filter = filter + ` OR $Parent="Sundry Debtors"`

    let data = `
        <ENVELOPE>
            <HEADER>
                <VERSION>1</VERSION>
                <TALLYREQUEST>Export</TALLYREQUEST>
                <TYPE>Collection</TYPE>
                <ID>Collection of Ledgers</ID>
            </HEADER>
            <BODY>
                <DESC>
                    <STATICVARIABLES>
                        <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
                        <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                    </STATICVARIABLES>
                    <TDL>
                        <TDLMESSAGE>
                            <COLLECTION NAME="Collection of Ledgers" ISMODIFY="NO">
                                <FILTER>AlterId</FILTER>
                                <FETCH>GUID,ALTERID,MASTERID,CLOSINGBALANCE</FETCH>
                                <TYPE>Ledger</TYPE>
                            </COLLECTION>
                            <SYSTEM TYPE="FORMULAE" NAME="AlterId">${filter}</SYSTEM>
                        </TDLMESSAGE>
                    </TDL>
                </DESC>
            </BODY>
        </ENVELOPE>
    `

    data = xmlFormatter(data)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            if(!jsonData?.ENVELOPE?.BODY?.DATA?.COLLECTION?.LEDGER){
                return {
                    change: false,
                    status: true
                }
            }

            await SyncOutStandings(jsonData)

            return {
                status: true,
            }
        } else {
            return false
        }
    } catch (err) {
        return false
    }

}

export async function GetAccStatementOfParty(ledger, startDate, endDate) {

    let fromDate = moment(startDate).format("YYYYMMDD")
    let toDate = moment(endDate).format("YYYYMMDD")


    let data = `
        <ENVELOPE>
            <HEADER> 
                <TALLYREQUEST>Export Data</TALLYREQUEST> 
            </HEADER> 
            <BODY> 
                <EXPORTDATA> 
                    <REQUESTDESC> 
        
                        <STATICVARIABLES> 
        
                            <SVEXPORTFORMAT>$$SysName:HTML</SVEXPORTFORMAT>
                            <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                            <SVFROMDATE>${fromDate}</SVFROMDATE>
                            <SVTODATE>${toDate}</SVTODATE>
                            <DBBILLEXPLODEFLAG>YES</DBBILLEXPLODEFLAG>
                            <EXPLODEVNUM>YES</EXPLODEVNUM>
                            <LEDGERNAME>${ledger?.name}</LEDGERNAME> 
        
                        </STATICVARIABLES>
                        <REPORTNAME>Ledger Vouchers</REPORTNAME>
                    </REQUESTDESC> 
                </EXPORTDATA> 
            </BODY> 
        </ENVELOPE>
    `

    data = xmlFormatter(data)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data,
            isHtml: true
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            let htmlString = await compressHtml(jsonData)

            await SyncAccStatment(ledger, htmlString, TallyConfig.company)

            return {
                status: true,
            }
        } else {
            console.log("getAccStatement", resp)
            return false
        }
    } catch (err) {
        console.log("getAccStatement catch", err)
        return false
    }
}

export async function GetStockSummary() {

    let data = `
        <ENVELOPE>
            <HEADER>
                <VERSION>1</VERSION>
                <TALLYREQUEST>Export</TALLYREQUEST>
                <TYPE>Collection</TYPE>
                <ID>Collection of Ledgers</ID>
            </HEADER>
            <BODY>
                <DESC>
                    <STATICVARIABLES>
                        <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
                        <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                    </STATICVARIABLES>
                    <TDL>
                        <TDLMESSAGE>
                            <COLLECTION NAME="Collection of Ledgers" ISMODIFY="NO">
                                <FILTER>AlterId</FILTER>
                                <FETCH>MASTERID,CLOSINGBALANCE,CLOSINGVALUE</FETCH>
                                <TYPE>StockItem</TYPE>
                            </COLLECTION>
                            <SYSTEM TYPE="FORMULAE" NAME="AlterId">$masterid &gt; 0</SYSTEM>
                        </TDLMESSAGE>
                    </TDL>
                </DESC>
            </BODY>
        </ENVELOPE>
    `

    data = xmlFormatter(data)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            if(!jsonData?.ENVELOPE?.BODY?.DATA?.COLLECTION?.STOCKITEM){
                return {
                    change: false,
                    status: true
                }
            }

            await SyncStockSummary(jsonData)

            return {
                status: true,
            }
        } else {
            return false
        }
    } catch (err) {
        return false
    }

}